import {
  IContactFormField,
  IContactFormOption,
  IDisplayFields,
} from '@shared/components/@organisms/UCContactForm/types';

import { ISBContactFormField, ISBContactFormOption, ISBDisplayFields } from './types';

export const transformDisplayFields = (field: ISBDisplayFields): IDisplayFields => ({
  id: field._uid,
  fields: field.fields,
});

export const transformContactFormOption = (option: ISBContactFormOption): IContactFormOption => ({
  ...option,
  id: option._uid,
  formLabel: option.form_label,
  fieldDescription: option.field_description,
  dropdownOptions: option.dropdown_options?.map(transformContactFormOption),
  mandatoryFields: option.mandatory_fields
    ? transformDisplayFields(option.mandatory_fields)
    : undefined,
  fieldsToDisplay: transformDisplayFields(option.fields_to_display),
  parentArr: option.parentArr?.map(transformContactFormOption),
});

export const transformContactFormProps = (field: ISBContactFormField): IContactFormField => ({
  ...field,
  id: field._uid,
  formLabel: field.form_label,
  fieldDescription: field.field_description,
  isRequired: field.is_required,
  isEnquirySpecific: field.is_enquiry_specific,
  visibleOnStart: field.visible_on_start,
  dropdownOptions: field.dropdown_options?.map(transformContactFormOption),
});
